import { EntityLabels } from '@web-shared/types';
import { EBOL_STATUS } from '../../../../../../api/types/EbolStatus';

export const ebolStatusLabels: EntityLabels<EBOL_STATUS> = {
  [EBOL_STATUS.ACCEPTED]: 'label_acceptedEbol',
  [EBOL_STATUS.REJECTED]: 'label_rejectedEbol',
  [EBOL_STATUS.ACCEPTED_WITH_DISCREPANCIES]: 'label_acceptedWithDiscrepanciesEbol',
};

export const ebolStatusBackgroundColors: EntityLabels<EBOL_STATUS> = {
  [EBOL_STATUS.ACCEPTED]: 'success.container',
  [EBOL_STATUS.REJECTED]: 'error.container',
  [EBOL_STATUS.ACCEPTED_WITH_DISCREPANCIES]: 'warning.container',
};